// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DashboardTwoToneSvg from "@ant-design/icons-svg/es/asn/DashboardTwoTone";
import AntdIcon from '../components/AntdIcon';

var DashboardTwoTone = function DashboardTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DashboardTwoToneSvg
  }));
};

DashboardTwoTone.displayName = 'DashboardTwoTone';
export default React.forwardRef(DashboardTwoTone);